/* ERAA custom behaviours */
(function () {
  var FIELDSET_SELECTOR =
    '.shopify-section--featured-collections .product-card__info fieldset,' +
    '.shopify-section--related-products .product-card__info fieldset';

  var mobileQuery = window.matchMedia('(max-width: 767px)');

  // Inject a clickable "+" toggle into any swatch row that has more than 4 colors.
  // The condensed 4-colors view is a mobile-only layout, so only run there.
  function setupSwatchToggles() {
    if (!mobileQuery.matches) return;

    document.querySelectorAll(FIELDSET_SELECTOR).forEach(function (fieldset) {
      if (fieldset.dataset.swatchMoreReady === '1') return;

      var swatches = fieldset.querySelectorAll('.color-swatch');
      if (swatches.length <= 4) return;

      fieldset.dataset.swatchMoreReady = '1';

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'swatch-more-toggle';
      toggle.setAttribute('aria-label', 'Show all colors');
      toggle.textContent = '+';
      fieldset.appendChild(toggle);
    });
  }

  // Reveal the remaining colors when the "+" is clicked (event delegation).
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('.swatch-more-toggle');
    if (!toggle) return;

    event.preventDefault();
    var fieldset = toggle.closest('fieldset');
    if (fieldset) fieldset.classList.add('is-expanded');
  });

  // Run now and after async content (e.g. product recommendations) loads.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      setupSwatchToggles();
    });
  }

  if (document.readyState !== 'loading') {
    setupSwatchToggles();
  } else {
    document.addEventListener('DOMContentLoaded', setupSwatchToggles);
  }
  window.addEventListener('load', setupSwatchToggles);
  (mobileQuery.addEventListener
    ? mobileQuery.addEventListener.bind(mobileQuery, 'change')
    : mobileQuery.addListener.bind(mobileQuery))(schedule);

  // Catch cards that are inserted later (related products fetch, tab swaps).
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
